import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Import the App component
import './styles/tailwind.css'; // Make sure this path matches your folder structure

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App /> {/* Render App component */}
  </React.StrictMode>
);
